module.exports = {"id":"dp5_1l1q4","text":"Common technical issues","instructions":"Which situation is an example of a common technical problem?","multiselect":false,"category":"5.1","questionType":"PickOne","random":true,"options":[{"id":"dp5_1l1q4-a1","text":"Unable to connect to Wi-Fi","score":1.8},{"id":"dp5_1l1q4-a2","text":"Choosing a new device colour","score":0},{"id":"dp5_1l1q4-a3","text":"Creating a strong password","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l1q4.json
// module id = 1284
// module chunks = 41